import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";

const maxRetries = 2;

const baseQuery = retry(
	fetchBaseQuery({
		baseUrl: process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE,
	}),
	{ maxRetries }
);

export const chartAPI = createApi({
	reducerPath: "chartAPI",
	baseQuery,
	keepUnusedDataFor: 0,
	tagTypes: [],
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		//* *********************************************************** */
		//* GET FAULT CHARTS */
		postFaultChart: builder.mutation({
			query: (body: any) => ({
				url: "/reports/faults/chart",
				body: body.body,
				method: "post",
				headers: { authorization: body.token },
			}),
		}),
		//* *********************************************************** */
	}),
});

export const { usePostFaultChartMutation } = chartAPI;
